import env from '@platform-ui/utilities/env.js';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { Auth, browserLocalPersistence, connectAuthEmulator, getAuth } from 'firebase/auth';

let app: FirebaseApp;
let auth: Auth;

const {
  REACT_APP_IDENTITY_CLIENT_API_KEY: apiKey,
  REACT_APP_IDENTITY_AUTH_DOMAIN: authDomain,
  STORYBOOK: useMock,
} = env();

const missingFirebaseConfig = !apiKey || !authDomain;

if (useMock || missingFirebaseConfig) {
  app = null;
  auth = null;
} else {
  app = initializeApp({ apiKey, authDomain });
  auth = getAuth(app);
  // Without optional chain this line breaks a chunk of our unit tests
  auth?.setPersistence(browserLocalPersistence);
  if (process.env.NODE_ENV === 'development') {
    connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  }
}

export { app, auth };
